import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import firebase from 'firebase'
import { userRef, ROOT_VIEW } from '../../config'
import logo from '../../assets/img/login2.png';

export default class Login extends Component {
  constructor(props) {
    super(props)
    this.handleLogin = this.handleLogin.bind(this)
    this.onEmailChange = this.onEmailChange.bind(this)
    this.onPasswordChange = this.onPasswordChange.bind(this)
    this.state = {
      error: null,
      loader: false
    }
  }

  onEmailChange(e) {
    this.setState({
      email: e.target.value
    })

  }
  onPasswordChange(e) {
    this.setState({
      password: e.target.value
    })

  }
  handleLogin(e) {

    e.preventDefault();

    console.log('handling login')
    this.setState({
      loader: true
    })
    if(this.state.email && this.state.password){
      console.log('logging in')
        firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
        .then(user => userRef.child(user.uid).once('value', s => {
          if(s.exists()) {
            Object.keys(s.val()).forEach(k => {
              console.log('got key', k)
              localStorage.setItem(k, s.val()[k])
            })
            localStorage.setItem('loggedIn', true)
            if(s.val().pendingApproval) {
              return this.props.history.push('PendingApproval')
            }
            else if(s.val().accountStatus === 'disabled') {
              return this.props.history.push('AccountDisabled')
            }
            else {
              return this.props.history.push(ROOT_VIEW)

            }
          }
        }))
        .catch(error => {
          console.log('got error', error)
          this.setState({
            error: error.message,
            loader: false
          })
        })
    }else{
        this.setState({
          loader: false,
          error: 'Please fill all field'
        })
    }



  }
  render() {
      if(this.state.loader){
          return (<div className="loader-wrap">
            <div className="loader">Loading...</div>
          </div>)
      }else{
          return (
      		<div className='login-wrap'>
      			<div className='center-align'>
      				<div className='container'>
      					<div className='logo-login text-center'>
                  <img className='img-responsive' src={logo}/>
      					</div>
      					<div className="row flex-row align-center">
      						<div className="col-sm-3 hidden-xs col-md-4">
      							<div className="login-line"></div>
      						</div>

      						<div className="col-sm-6 col-xs-12 col-md-4 login-form">
                              {this.state.error ? <p className='info text-danger'> {this.state.error} </p>: null}
      						<form>
      							<div className="form-group">
      								<div className="input-group">
      									<span className="input-group-addon"><i className="icon ion-ios-person-outline"></i></span>
      									<input type="text" className="form-control" onChange={this.onEmailChange} placeholder="USERNAME" />
      								</div>

      							</div>
      							<div className="form-group">
      								<div className="input-group">
      									<span className="input-group-addon">
      										<i className="icon ion-ios-unlocked-outline"></i>
      									</span>
      									<input type="password" autoComplete="off" className="form-control" onChange={this.onPasswordChange} placeholder="PASSWORD" />
      								</div>
      							</div>
      							<a className="forget-password" href="#">
      								Forgot Password?
      							</a>
      							<div className="text-center">
      								<button className="btn btn-login btn-primary" onClick={this.handleLogin} type="submit">LOGIN</button>
      							</div>
      						</form>
      						</div>
      						<div className="col-sm-3 hidden-xs col-md-4">
      							<div className="login-line"></div>
      						</div>
      					</div>
      					<div className="text-center register-col">
      						Don't have an account? <Link to='/signup'> Register </Link>
      					</div>
      				</div>
      			</div>
      		</div>
        )
      }

  }
}



// WEBPACK FOOTER //
// ./src/views/Login/Login.js